<anon-headline>
  <ng-container header>Users</ng-container>
  <ng-container subheader>All user accounts created will show here.</ng-container>
</anon-headline>

<ng-container *ngIf="users$ | async as users; else loadingOrError">
  <ng-container *ngIf="users.length > 0; else noUsers">
    <em>{{users.length}} {{users.length === 1 ? 'user' : 'users'}}</em>
    <div class="user" *ngFor="let user of users">
      <div class="user-info">
        <h2 class="title">{{user.displayName}}</h2>
        <p>{{user.email}}</p>
        <div class="bottom">
          <span>Joined: {{user.joined?.seconds! * 1000 | date}}</span>
          <div class="icons">
            <mat-icon *ngIf="user.admin" color="accent">admin_panel_settings</mat-icon>
          </div>
        </div>
      </div>
      <div class="user-actions">
        <anon-user-photo [user]="user"></anon-user-photo>
      </div>
    </div>
  </ng-container>
  <ng-template #noUsers>
    <div class="">
      <h2 class="">No users yet!</h2>
      <p class="">Spread the word and invite others to join the platform.</p>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
